<template>
    <div class="part1" id="animate1">
        <div class="img-container">
            <div class="img-box">
                <img id="img1" class="img-show" src="/assets/~/media/images/activity/2026summer/pc/7.png" alt="">
            </div>
            <div style="margin-left: calc(18 / 2200 * 100vw);" class="img-box">
                <img id="img2" class="img-show" src="/assets/~/media/images/activity/2026summer/pc/8.png" alt="">
            </div>
        </div>
    </div>
  </template>

  <script>
  import { isPortraitFun, getUrlKey } from "@/utils/utils.js";
  // import Firstpage from "./Firstpage.vue";
  export default {
    data() {
      return {
        isPortrait: isPortraitFun(),
        minip: false,
      };
    },
    mounted: function () {
  /**
        window.addEventListener('scroll', function() {
            var vh = window.innerHeight;
            var vw = window.innerWidth;
            var Container1Element = document.getElementById('animate1');
            var pageTop= document.getElementById("animate1").getBoundingClientRect().top
            var imgElement1 = document.querySelector('#img1')
            var imgElement2 = document.querySelector('#img2')
            if(pageTop <= vh/2){
                imgElement1.classList.add('img-show');
                imgElement2.classList.add('img-show');
            }
            else if( pageTop > vh/2 && pageTop <= vh  ){
                imgElement1.classList.remove('img-show');
                imgElement2.classList.remove('img-show');
            }
        })
   **/
    },
    methods: {
    },
  };
  </script>

  <style lang="scss" scoped>
  .part1 {
    //   background-color: #f0ede5;
    //     background-image:  url('https://uat.kia.cn/assets/~/media/images/activity/2026summer/pc/part1-bg.jpg');
    //     background-size: cover;
        width: 100%;
        height: calc(1025 / 1920 * 100vw);
        padding-top: calc(188 / 1920 * 100vw);
        padding-bottom: calc(80 / 1920 * 100vw);
        display: flex;
        align-items: center;
        justify-content: center;
        .img-container {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .img-box {
            // border: dashed 1px grey ;
            img {
                width: calc(720 / 1920 * 100vw);
                height: calc(869 / 1920 * 100vw);
                clip-path: inset(0 0 0 100%);
                transition: all 1s;
                transition-delay: 0s;
            }
            .img-show {
                clip-path: inset(0 0 0 0);
                transition-delay: 0.5s;
            }
        }
  }

  </style>
